export function getCurrencyDisplayFromDollars({
  amount,
  hideCents,
}: {
  amount: string | number | null;
  hideCents?: boolean;
}) {
  if (amount == null) {
    return '';
  }
  if (typeof amount === 'string') {
    amount = parseFloat(amount.replace(/[^0-9.]/g, ''));
  }

  if (isNaN(amount)) {
    return '';
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: hideCents ? 0 : 2,
    minimumFractionDigits: 0,
  }).format(amount);
}

export function getCurrencyDisplayFromCents({
  amount,
  hideCents,
}: {
  amount: string | number | null;
  hideCents?: boolean;
}) {
  if (amount == null) {
    return '';
  }
  let numericAmount: number;
  if (typeof amount === 'string') {
    numericAmount = parseFloat(amount.replace(/[^0-9.]/g, ''));
  } else {
    numericAmount = amount;
  }
  if (isNaN(numericAmount)) {
    return '';
  }
  return getCurrencyDisplayFromDollars({ amount: numericAmount / 100, hideCents });
}
